import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    saveTemplateBeforePublish: {
      type: Boolean,
      default: true
    }
  },

  computed: _extends({}, mapState({
    templateId: function templateId(state) {
      return state.creative.template.templateId;
    },
    customPublishing: function customPublishing(state) {
      return state.creative.template.customPublishing;
    }
  }), {
    buttonAttrs: function buttonAttrs() {
      return {
        loading: this.customPublishing,
        text: '推送到 PlayTurbo',
        type: 'primary',
        size: 'mini'
      };
    }
  }),

  methods: _extends({}, mapActions({
    saveTemplate: 'creative/template/saveTemplate',
    publishCustom: 'creative/template/publishCustom'
  }), {
    handleClick: function handleClick() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.saveTemplateBeforePublish) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.saveTemplate();

              case 3:
                _context.next = 5;
                return _this.publishCustom();

              case 5:
                res = _context.sent;

                if (res) {
                  _this.$message.success('推送成功');
                } else {
                  _this.$message.error('推送失败');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
};